import { render, staticRenderFns } from "./orderHistoryMoreDetail.vue?vue&type=template&id=3e96439d&"
import script from "./orderHistoryMoreDetail.vue?vue&type=script&lang=js&"
export * from "./orderHistoryMoreDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports